(function () {
  const MAX_LINES = 5;
  /** Only show MORE / truncate when the quote is at least this long. */
  const MIN_CHARS = 200;

  function lineHeightPx(el) {
    const lh = getComputedStyle(el).lineHeight;
    const n = parseFloat(lh);
    if (Number.isFinite(n) && lh !== "normal") return n;
    return parseFloat(getComputedStyle(el).fontSize) * 1.55;
  }

  function maxHeightPx(el) {
    return lineHeightPx(el) * MAX_LINES + 1;
  }

  function fits(quote, maxH) {
    return quote.getBoundingClientRect().height <= maxH;
  }

  function truncateToFit(quote, textEl, btn, fullText, maxH) {
    btn.hidden = false;
    btn.textContent = "MORE";
    btn.setAttribute("aria-expanded", "false");

    let lo = 0;
    let hi = fullText.length;
    let best = "";

    while (lo <= hi) {
      const mid = (lo + hi) >> 1;
      let slice = fullText.slice(0, mid).replace(/\s+\S*$/, "").trimEnd();
      if (!slice && mid > 0) slice = fullText.slice(0, mid).trimEnd();
      textEl.textContent = slice ? slice + "…" : "";
      if (fits(quote, maxH)) {
        best = slice;
        lo = mid + 1;
      } else {
        hi = mid - 1;
      }
    }

    if (!best) {
      best = fullText.slice(0, Math.min(24, fullText.length)).trimEnd();
    }

    textEl.textContent = best + "…";
    if (!fits(quote, maxH)) {
      let s = best;
      while (s.length > 8 && !fits(quote, maxH)) {
        s = s.replace(/\s*\S+\s*$/, "").trimEnd();
        if (!s) break;
        textEl.textContent = s + "…";
      }
    }
  }

  function initQuote(quote) {
    const textEl = quote.querySelector(".testimonial-card__quote-text");
    const btn = quote.querySelector(".testimonial-card__more");
    if (!textEl || !btn) return;

    const fullText = (quote.getAttribute("data-full-quote") || textEl.textContent || "")
      .replace(/\s+/g, " ")
      .trim();
    if (!fullText) return;

    const applyCollapsed = () => {
      textEl.textContent = fullText;
      btn.hidden = true;
      quote.dataset.sfNeedsMore = "0";
      quote.dataset.sfExpanded = "0";

      if (fullText.length < MIN_CHARS) return;

      const maxH = maxHeightPx(quote);
      if (fits(quote, maxH)) return;

      quote.dataset.sfNeedsMore = "1";
      truncateToFit(quote, textEl, btn, fullText, maxH);
    };

    const applyExpanded = () => {
      quote.dataset.sfExpanded = "1";
      textEl.textContent = fullText + " ";
      btn.hidden = false;
      btn.textContent = "LESS";
      btn.setAttribute("aria-expanded", "true");
    };

    if (quote.dataset.sfQuoteInit !== "1") {
      quote.dataset.sfQuoteInit = "1";
      btn.addEventListener("click", () => {
        if (quote.dataset.sfExpanded === "1") applyCollapsed();
        else applyExpanded();
      });
    }

    if (quote.dataset.sfExpanded === "1" && fullText.length >= MIN_CHARS) applyExpanded();
    else applyCollapsed();
  }

  function initTestimonialQuotes(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(".testimonial-card__quote").forEach(initQuote);
  }

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => initTestimonialQuotes(), 150);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initTestimonialQuotes());
  } else {
    initTestimonialQuotes();
  }

  window.sfInitTestimonialQuotes = initTestimonialQuotes;
})();
